module.exports = __webpack_public_path__ + "static/media/ic_leading_reserve.e7ba142b.svg";